import { render, staticRenderFns } from "./crmUpdate.vue?vue&type=template&id=1bb961b0&"
import script from "./crmUpdate.vue?vue&type=script&lang=js&"
export * from "./crmUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports